<template>
  <div class="home" id="top">
    <v-container>
      <div class="home__top">
        Every case is different. Complete the steps and our app will calculate
        the fee.
      </div>
      <!--scan v-if="scanShow" @goToStep="goToStep" /-->
      <div class="steps-items" v-if="selectState && !isNationwide">
        <div class="v-stepper__content">
          <div class="step">
            <h1 class="step__title">In which state did you get your ticket?</h1>
            <v-form >
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12">
                   <vue-customer-autocomplete 
                  :items="states" 
                  v-model="state" 
                  :get-label="getLabel" 
                  @update-items="updateItems"
                  @input="state = $event"
                  @item-clicked="itemClicked"
                  :input-attrs="{id: 'autocompleteStateHome'}"
                  :min-len='0' 
                  placeholder="Select States"

                  >
                  </vue-customer-autocomplete>
                  <span v-show="state==null && count!=0" style="color: #ff5252 !important;font-size:0.71rem;">
                    State issued can't be empty.
                  </span>
                    <!-- <v-autocomplete
                      v-model="state"
                      label="Select State"
                      solo
                      :items="states"
                      item-text="name"
                      item-value="id"
                      return-object
                      :error-messages="stateErrors"
                      @change="$v.state.$touch()"
                      @blur="$v.state.$touch()"
                    ></v-autocomplete>  -->
                    </v-col
                ></v-row>
                <v-row>
                  <v-col cols="12" sm="12" class="mt-8">
                    <v-btn class="step__scan__button" block @click="submit"
                      >Continue</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </div>
        </div>
      </div>

      <nationwide v-if="isNationwide" />

      <!--v-stepper alt-labels class="steps" v-model="step" v-else-->
      <v-stepper
        alt-labels
        class="steps"
        v-model="step"
        v-if="!selectState && !isNationwide"
      >
        <v-stepper-header>
          <v-stepper-step step="1" :complete="step > 1"> 1 </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2" :complete="step > 2"> 2 </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3" :complete="step > 3"> 3 </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="4"> 4 </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items class="steps-items">
          <v-stepper-content step="1" class="step">
            <one @goToStep="goToStep"></one>
          </v-stepper-content>
          <v-stepper-content step="2">
            <two @goToStep="goToStep" />
          </v-stepper-content>
          <v-stepper-content step="3">
            <three @goToStep="goToStep" />
          </v-stepper-content>
          <v-stepper-content step="4">
            <five @goToStep="goToStep" :entry="entry" />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-container>

    <div class="home__bottom">
      <img src="@/assets/images/padlock.png" class="home__bottom__padlock" />
    </div>
  </div>
</template>

<script>
import('../assets/css/frontend-lite.min.css')
import('../assets/css/fontawesome.min.css')
import('../assets/css/solid.min.css')
import('../assets/css/brands.min.css')
import('../assets/css/animations.min.css')


import Scan from "../components/steps/Scan";
import Nationwide from "../components/steps/Nationwide";

import One from "../components/steps/One";
import Two from "../components/steps/Two";
import Three from "../components/steps/Three";
import Five from "../components/steps/Five";
import { isMobileOnly } from "mobile-device-detect";

import axios from "@/axios-auth";
import { validationMixin } from "vuelidate";
const { required } = require("vuelidate/lib/validators");

import { mapMutations , mapGetters } from "vuex";
import autocompleteNew from '../components/common/autocomplete/AutocompleteNew.vue'


export default {
  name: "Home",

  components: {
    Scan,
    One,
    Two,
    Three,
    Five,
    Nationwide,
    'vue-customer-autocomplete': autocompleteNew
  },
  mixins: [validationMixin],
  validations: {
    state: { required },
  },
  data() {
    return {
      entry: false,
      step: 1,
      count:0,
      scanShow: false,
      state:  null,
      states: [],
      statesInit:[],
      selectState: false,
      isNationwide: false,
    };
  },
  methods: {
    ...mapMutations(["setStateSelected"]),
    created(){
    
    },
    submit() {
      this.count++;
      this.$v.$touch();

      if (!this.$v.$invalid) {
        if (this.state && (this.state.iso_code == "FL" || this.state.iso_code == "CA")) {

          if(this.state.iso_code == "FL"){
            this.selectState = false;
            this.setStateSelected(this.state);
            this.isNationwide = false;

          } else {
          location.href = process.env.VUE_APP_URL_CALIFORNIA;

          } 
        } else {
          // this.isNationwide = true;
         location.href = process.env.VUE_APP_URL_OTHER_STATES;
        }
      }
    },
    getLabel (item) {
      if(item){
        return item.name
      }
      
    },
    itemClicked(item){
      this.states = this.statesInit;
    },
    updateItems (text){
      this.count++;
      if(text != '' && text != undefined){
          this.states = this.statesInit.filter(item => {
            return (new RegExp(text.toLowerCase())).test(item.name.toLowerCase())
          })
      }else{
        this.states = this.statesInit;
      }
    },
    goToStep(n) {
      this.scanShow = false;
      this.step = n;
      if(n == 4){
        this.entry = !this.entry;
      }
      this.$vuetify.goTo("#top", {
        duration: 300,
        offset: 0,
        easing: "linear",
      });
    },
    loadStates() {
      this.states = [];
      axios
        .get(`v1/states`)
        .then((response) => {
          return response.data;
        })
        .then((res) => {
          if (res) {
           
            this.statesInit = res.data;
            this.states =res.data;
          }
        });
    },
  },

  mounted() {
    if (isMobileOnly) {
      this.scanShow = true;
    }
    this.loadStates();

    if (this.$route.query.state) {
      this.selectState = false;
      if (this.$route.query.state.toString().toUpperCase() != "FL") {
        this.isNationwide = true;
      } else {
        this.isNationwide = false;
      }
    } else {
      this.selectState = true;
    }
  },
  computed: {
    stateErrors() {
      const errors = [];
      if (!this.$v.state.$dirty) return errors;
      !this.$v.state.required && errors.push("State issued can't be empty.");
      return errors;
    },
  },
  // watch: {
  //   state(val) {
  //     if (val) {
  //       if (val.iso_code == "FL") {
  //         this.isNationwide = false;
  //       } else {
  //         this.isNationwide = true;
  //       }
  //     }
  //   },
  // },
};
</script>
